import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import logo from "../../assets/logo.svg";
import db from "../../firebase.config";
import {
  collection,
  getDocs,
  query,
  addDoc,
  where,
  limit,
  setDoc,
  doc,
} from "firebase/firestore";
import Card from "../../components/card";
import Filters from "../../components/filter";
import styled from "styled-components";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import {
  COLOR_BLUE,
  COLOR_GREEN,
  COLOR_GREEN_BUTTON,
  COLOR_WHITE,
} from "../../constants/colors";
import {
  SORT_VALUES,
  DATE_DOWN,
  DATE_UP,
  PRICE_DOWN,
  PRICE_UP,
  LOCATION_FILTER,
  TYPES_FILTER,
  SURFACE_FILTER,
  BUDGET_FILTER,
  ROOMS_FILTER,
} from "../../constants/filter";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {
  ANNONCE_COLLECTION,
  TMP_USERS_COLLECTION,
} from "../../constants/firestoreCollection";
import { SEND_EMAIL_CONFIRMATION_URL } from "../../constants/cloudFunctions";
import axios from "axios";
import { IAnnonceInterface } from "../../interfaces/annonce";
import { groupBy } from "lodash";

const Wrapper = styled.div`
  dislay: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  width: 100%;
`;

const HeaderFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 40px;
  background-color: ${COLOR_WHITE};
  width: 100vw;
  z-index: 50;
  overflow: visible;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.04);
  @media screen and (max-width: 1200px) {
    padding: 50px 20px;
    display: flex;
    flex-direction: column;
    height: auto;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 76px;
  height: 110px;
  overflow: visible;

  .nbr-announces {
    font-size: 26px;
    font-weight: bold;
    color: ${COLOR_BLUE};
  }
`;

const SortFilter = styled.div`
  margin-left: auto;
  margin-top: 20px;
  z-index: 2;

  .icon {
    font-size: big;
    margin-left: 18px;
  }

  .main-btn {
    width: 284px;
    height: 49px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    border-radius: 10px;
    background-color: ${COLOR_GREEN_BUTTON};
    color: ${COLOR_GREEN};
  }

  button {
    border: none;
    border-radius: 0px;
    font-size: 18px;
    font-weight: bold;
    margin-top: 0;
    padding: 10px;
    color: ${COLOR_BLUE};
    background-color: ${COLOR_WHITE};
  }

  button:hover {
    cursor: pointer;
    background-color: ${COLOR_GREEN_BUTTON};
    color: ${COLOR_GREEN};
  }
`;

const SortValues = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  border-box: box-sizing;
  padding: 0;
  border-radius: 13px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.06);

  .selected {
    background-color: ${COLOR_GREEN_BUTTON};
    color: ${COLOR_GREEN};
  }

  button:first-child {
    border-radius: 13px 13px 0 0;
  }

  button:last-child {
    border-radius: 0 0 13px 13px;
  }
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  gap: 39px;
  z-index: 1;
  position: relative;

  .no-results {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 25px;
    color: ${COLOR_GREEN};
  }

  @media screen and (max-width: 1400px) {
    grid-template-columns: repeat(2, auto);
  }

  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(1, auto);
  }
`;

const SubscribeNewsletter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 4%;
  padding: 60px 150px;
  border-radius: 10px;
  background-color: ${COLOR_GREEN_BUTTON};
  color: ${COLOR_GREEN};
  font-weight: bold;
  font-size: 26px;
  text-align: center;

  form {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    width: 80%;
  }

  input.email {
    width: 60%;
    border-radius: 7px;
    border: none;
    padding: 26px 33px;
    margin: 0 auto;
    font-size: 16px;
  }

  .submit {
    border-radius: 5px;
    border: none;
    padding: 10px 15px;
    font-weight: bold;
    font-size: 18px;
    margin: 40px auto;
    color: ${COLOR_WHITE};
    background-color: ${COLOR_GREEN};
  }

  .submit:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 1300px) {
    padding: 40px 0px;
    font-size: 24px;
  }
`;

const CardDiv = styled.div`
  display: flex;
  align-items: stretch;
`;

interface IRange {
  min: number;
  step: number;
  label: string;
  shortLabel: string;
}

export interface IFilterArray {
  name: string;
  values?: string[];
  selectedValues?: string[];
  data?: IRange;
  handleChange?: (name: string, value: string) => void;
  handleInput?: (value: number, name: string) => void;
}

const getData = async (
  _setAnnonces: Dispatch<SetStateAction<IAnnonceInterface[]>>,
  _setExistingCities: Dispatch<SetStateAction<string[]>>,
  _setExistingTypes: Dispatch<SetStateAction<string[]>>
) => {
  let annonceRef = null;
  let annonceSnap = null;

  _setExistingCities([]);

  annonceRef = query(
    collection(db, ANNONCE_COLLECTION),
    where("visible", "in", [1, "true", true])
  );
  annonceSnap = await getDocs(annonceRef);

  const annonceList: IAnnonceInterface[] = [];
  annonceSnap.forEach((doc) => {
    const data = doc.data();
    const images =
      data.mainImage && data.mainImage !== "null" ? data.mainImage : logo;
    const dateRendered =
      data.date && data.date !== "null" ? data.date.replace(/"/g, "") : null;
    let date = dateRendered ? dateRendered : null;
    if (date) {
      const splitDate = date.split("/");
      if (splitDate.length === 3) {
        date = new Date(splitDate[2], +splitDate[1] - 1, splitDate[0]);
      } else {
        const splitDateDot = date.split("-");
        if (splitDateDot.length === 3) {
          date = new Date(
            splitDateDot[2],
            +splitDateDot[1] - 1,
            splitDateDot[0]
          );
        }
      }
    }

    annonceList.push({
      id: doc.id,
      address: data.address,
      author: data.author,
      bedrooms: data.bedrooms,
      city: data.city,
      consumption: data.consumption !== "null" ? data.consumption : null,
      date,
      dateRendered,
      description: data.description,
      gasEmission: data.gasEmission,
      globalInfos: data.globalInfos,
      phone: data.phone,
      postcode: data.postcode,
      price: +data.price || data.price,
      reference: data.reference,
      rooms:
        data.rooms && data.rooms !== undefined
          ? +data.rooms || data.rooms
          : undefined,
      surface: data.surface && data.surface !== "null" ? +data.surface : null,
      mainImage: images,
      images: data.mainImage ? data.images : logo,
      type: data.type,
    });
  });

  _setExistingCities(
    Object.keys(
      groupBy(
        annonceList.filter((a) => a.city),
        "city"
      )
    )
  );
  _setExistingTypes(
    Object.keys(
      groupBy(
        annonceList.filter((a) => a.type),
        "type"
      )
    )
  );
  console.log(annonceList);
  _setAnnonces(annonceList);
  return null;
};

const AnnoncesList = (props: any) => {
  const [filterValue, _setFilterValue] = useState<string>(DATE_DOWN);
  const [buttonState, _setButtonState] = useState<boolean>(false);
  const [annoncesFiltered, _setAnnoncesFiltered] = useState<
    IAnnonceInterface[]
  >([]);
  const [annonces, _setAnnonces] = useState<IAnnonceInterface[]>([]);
  const [existingCities, _setExistingCities] = useState<string[]>([]);
  const [selectedCities, _setSelectedCities] = useState<string[]>([]);
  const [selectedTypes, _setSelectedTypes] = useState<string[]>([]);
  const [existingTypes, _setExistingTypes] = useState<string[]>([]);
  const [selectedSurface, _setSelectedSurface] = useState<number>(0);
  const [selectedBudget, _setSelectedBudget] = useState<number>(0);
  const [selectedRooms, _setSelectedRooms] = useState<number>(0);
  const [subscribed, _SetSubscribed] = useState<boolean>(false);
  const [sortBy, _setSortBy] = useState<string>(DATE_DOWN);

  // load datas
  useEffect(() => {
    getData(_setAnnonces, _setExistingCities, _setExistingTypes);
    document.title = "Nos annonces disponibles";
  }, []);

  useEffect(() => {
    let list = [...annonces];
    if (selectedCities && selectedCities.length) {
      list = list.filter((l) => selectedCities.indexOf(l.city) !== -1);
    }
    if (selectedTypes && selectedTypes.length) {
      list = list.filter((l) => selectedTypes.indexOf(l.type) !== -1);
    }

    if (selectedSurface) {
      list = list.filter((l) => l.surface && selectedSurface <= l.surface);
    }
    if (selectedBudget) {
      list = list.filter((l) => selectedBudget >= l.price);
    }
    if (selectedRooms) {
      list = list.filter((l) => selectedRooms <= l.rooms);
    }

    if (sortBy === DATE_DOWN || sortBy === DATE_UP) {
      list = list.sort((a, b) => {
        const v1: Date = new Date(a.date || new Date(2021, 0, 0));
        const v2: Date = new Date(b.date || new Date(2021, 0, 0));
        if (DATE_UP === sortBy) {
          return v1.getTime() - v2.getTime();
        } else {
          return v2.getTime() - v1.getTime();
        }
      });
    }

    if (sortBy === PRICE_DOWN || sortBy === PRICE_UP) {
      list = list.sort((a, b) => {
        if (PRICE_UP === sortBy) {
          return Number(a.price) - Number(b.price);
        } else {
          return Number(b.price) - Number(a.price);
        }
      });
    }

    _setAnnoncesFiltered(list);
  }, [
    selectedCities,
    selectedTypes,
    selectedSurface,
    selectedBudget,
    selectedRooms,
    annonces,
    sortBy,
  ]);

  const handleClick = (value: string) => {
    _setFilterValue(value);
    _setButtonState(!buttonState);
    _setSortBy(value);
  };

  const handleChange = (name: string, value: string): void => {
    if (value) {
      switch (name) {
        case LOCATION_FILTER: {
          if (selectedCities.includes(value))
            _setSelectedCities((selectedcCities) =>
              selectedcCities.filter((city) => city !== value)
            );
          else
            _setSelectedCities((selectedCities) => [...selectedCities, value]);
          break;
        }
        case TYPES_FILTER: {
          if (selectedTypes.includes(value))
            _setSelectedTypes((selectedTypes) =>
              selectedTypes.filter((type) => type !== value)
            );
          else _setSelectedTypes((selectedTypes) => [...selectedTypes, value]);
          break;
        }
      }
    }
  };

  const handleInput = (value: number, name: string) => {
    switch (name) {
      case SURFACE_FILTER:
        value !== selectedSurface && _setSelectedSurface(value);
        break;
      case BUDGET_FILTER:
        value !== selectedBudget && _setSelectedBudget(value);
        break;
      case ROOMS_FILTER:
        value !== selectedRooms && _setSelectedRooms(value);
        break;
    }
  };

  const handleSubscription = async (e: any) => {
    e.preventDefault();
    const email: string = e.target.email.value;
    const usersRef = query(
      collection(db, TMP_USERS_COLLECTION),
      where("email", "==", email),
      limit(1)
    ); // query docuemnts in "Users" collection which contains a "email" key with value equal to email
    const usersSnap = await getDocs(usersRef); // gets a list of document corresponding to the query

    // Check if the user is already registered.
    //       If yes, do not add the user but check if the subscribed value is true.
    //            If not,  change value to true and send confirmation email
    //            If yes, send alert to inform the user
    //       If not, add user and send confirmation email
    if (usersSnap.size === 0) {
      await addDoc(collection(db, TMP_USERS_COLLECTION), {
        email: email,
        subscribed: true,
      });

      axios
        .post(SEND_EMAIL_CONFIRMATION_URL + `?email=${email}`)
        .then((response) => console.log("response:", response.data))
        .catch((err) => console.log("error:", err));
      _SetSubscribed(true);
    } else {
      usersSnap.forEach((user) => {
        if (user.data().subscribed === false) {
          const userRef = doc(db, TMP_USERS_COLLECTION, user.id);
          setDoc(userRef, { subscribed: true }, { merge: true });

          axios
            .post(SEND_EMAIL_CONFIRMATION_URL + `?email=${email}`)
            .then((response) => console.log("response:", response.data))
            .catch((err) => console.log("error:", err));
          _SetSubscribed(true);
        } else {
          alert("Vous êtes déja inscrit à notre newsletter");
        }
      });
    }
  };

  const FilterArray: IFilterArray[] = [
    {
      name: LOCATION_FILTER,
      values: existingCities,
      selectedValues: selectedCities,
      handleChange: handleChange,
    },
    {
      name: TYPES_FILTER,
      values: existingTypes,
      selectedValues: selectedTypes,
      handleChange: handleChange,
    },
    {
      name: SURFACE_FILTER,
      data: { min: 0, step: 5, label: "m²", shortLabel: "m²" },
      handleChange: handleChange,
      handleInput: handleInput,
    },
    {
      name: BUDGET_FILTER,
      data: { min: 0, step: 10, label: "€", shortLabel: "€" },
      handleChange: handleChange,
      handleInput: handleInput,
    },
    {
      name: ROOMS_FILTER,
      data: { min: 1, step: 1, label: "pièce(s) ou plus", shortLabel: "" },
      handleChange: handleChange,
      handleInput: handleInput,
    },
  ];

  return (
    <>
      <HeaderFilter>
        {FilterArray.map((array) => (
          <Filters
            name={array.name}
            values={array.values}
            selectedValues={array.selectedValues}
            data={array.data}
            handleChange={array.handleChange}
            handleInput={array.handleInput}
            key={FilterArray.indexOf(array)}
          />
        ))}
      </HeaderFilter>
      <Wrapper>
        <Header>
          {
            <>
              <div className="nbr-announces">
                {annoncesFiltered.length}{" "}
                {annoncesFiltered.length > 1 ? (
                  <>biens immobiliers</>
                ) : (
                  <>bien immobilier</>
                )}{" "}
                à louer
              </div>
              <SortFilter>
                <button
                  onClick={() => _setButtonState(!buttonState)}
                  className="main-btn"
                >
                  Trier: {filterValue}
                  {(!buttonState && <ExpandMoreIcon className="icon" />) || (
                    <ExpandLessIcon className="icon" />
                  )}
                </button>
                {buttonState && (
                  <SortValues>
                    {SORT_VALUES.map((value) => (
                      <button
                        onClick={() => handleClick(value)}
                        key={SORT_VALUES.indexOf(value)}
                        className={value === filterValue ? "selected" : ""}
                      >
                        {value}
                      </button>
                    ))}
                  </SortValues>
                )}
              </SortFilter>
            </>
          }
        </Header>
        <Content>
          {(annoncesFiltered.length > 0 &&
            annoncesFiltered.map((annonce) => (
              <CardDiv key={annonce.reference}>{Card({ annonce })}</CardDiv>
            ))) || (
            <div className="no-results">
              Aucune annonce ne correspond à votre recherche
            </div>
          )}
        </Content>
        <SubscribeNewsletter>
          {(subscribed && (
            <>
              <DoneOutlineIcon />
              <div>Merci pour votre inscription</div>
            </>
          )) || (
            <>
              <div>Restez à l'affût des nouvelles annonces !</div>
              <form onSubmit={handleSubscription}>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="email"
                  required
                  placeholder="Entrer votre email"
                />
                <input type="submit" className="submit" value="Envoyé !" />
              </form>
            </>
          )}
        </SubscribeNewsletter>
      </Wrapper>
    </>
  );
};

export default AnnoncesList;
